import * as React from 'react'
import { Button } from './button'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { cn } from '../utils/utils'

interface ReadMoreProps {
    children: React.ReactNode
    className?: string
    readMoreLabel?: string
    showLessLabel?: string
    onOpenChange?: (open: boolean) => void
}

export const ReadMore = ({
    children,
    className,
    readMoreLabel = 'Read more',
    showLessLabel = 'Show less',
    onOpenChange,
}: ReadMoreProps) => {
    const [open, setOpen] = React.useState(false)

    const toggleOpen = (open: boolean) => {
        setOpen(open)
        if (onOpenChange) {
            onOpenChange(open)
        }
    }

    return (
        <div>
            <div className={cn(`${!open ? `overflow-hidden !h-[100px] mb-4` : ''}`, className)}>{children}</div>
            <Button
                variant={'link'}
                aria-expanded={open}
                onClick={() => toggleOpen(!open)}
                className="px-0 py-1 inline-flex justify-center text-black text-sm font-medium font-['Inter'] underline leading-6 hover:no-underline"
            >
                {open ? showLessLabel : readMoreLabel}
                {open ? <ChevronUpIcon className="ml-1 h-3 w-3" /> : <ChevronDownIcon className="ml-1 h-3 w-3" />}
            </Button>
        </div>
    )
}

export default ReadMore
